import sc from '../styled';
import link from './link.css';

const AnchorStyled = sc.a(link);
AnchorStyled.displayName = 'AnchorStyled';

export default AnchorStyled;
